import React, {useState} from "react";
import DsModal from "../_UI/dsModal";
import Form from "../_UI/dsModal/form.module.scss";
import {useDispatch, useSelector} from "react-redux";

import {sellToken, sellTokenFailure, setMatrixSellModalStatus} from "../../store/cabinet/action";
import ftfIcon from "../../theme/assets/redesign/wallet/token_ftf.webp";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";



const CabinetMatrixSellModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const matrixSellModalStatus = useSelector(store => store.cabinet.matrixSellModalStatus);
    const sellTokenStatusErr = useSelector(store => store.cabinet.sellTokenStatusErr);

    const userData = useSelector(store => store.cabinet.userData);

    const [amount, setAmount] = useState('');

    const handleChange = (e) => {
        let newValue = e.target.value;
        if (sellTokenStatusErr?.tokens){
            dispatch(sellTokenFailure(false));
        }
        // Разрешаем только цифры и точку
        newValue = newValue.replace(/[^0-9.]/g, '');

        // Разрешаем ввод только одной точки
        const parts = newValue.split('.');
        if (parts.length > 2) {
            newValue = parts[0] + '.' + parts.slice(1).join('');
        }

        setAmount(newValue);
    };

    const closeModal = () =>{
        dispatch(setMatrixSellModalStatus(false));
        setAmount('');
    }

    const toastHandler = () => {
      toast(t('Ваши токены успешно выставлены на продажу, ожидайте текущего завершения круга!'));
      closeModal();
    }

    const mainBtnHandler = () =>{
        dispatch(sellToken({tokens: amount}, toastHandler))
    }

    const amountNum = Number(amount) || 0;
    const rate = Number(userData?.token_rate) || 0;
    const canSell = amountNum > 0;

    return (
        <DsModal
            open={matrixSellModalStatus}
            onClose={closeModal}
            title={t('Продать токены')}
            subtitle={t('Введите количество токенов для продажи')}
        >
            <div className={Form.field}>
                <div className={`${Form.inputBox} ${sellTokenStatusErr?.tokens ? Form.inputBoxErr : ''}`}>
                    <input
                        type="text"
                        value={amount}
                        onChange={handleChange}
                        inputMode="decimal"
                        placeholder="0"
                        autoFocus
                    />
                    <span className={Form.suffix}>
                        <img src={ftfIcon} alt=""/>
                        FTF
                    </span>
                </div>
                <div className={Form.err}>{sellTokenStatusErr?.tokens ? sellTokenStatusErr.tokens : null}</div>
            </div>

            <div className={Form.info}>
                <div className={Form.infoRow}>
                    <span>{t('Доступно токенов')}</span>
                    <span>{Number(userData?.user?.tokens) || 0}</span>
                </div>
                <div className={Form.infoRow}>
                    <span>{t('Курс')}</span>
                    <span>1 FTF = {rate} USDT</span>
                </div>
                <div className={`${Form.infoRow} ${Form.infoRowTotal}`}>
                    <span>{t('Вы получите')}</span>
                    <span>{canSell ? `≈ ${(Math.round(amountNum * rate * 100) / 100).toLocaleString('ru-RU')} USDT` : '—'}</span>
                </div>
            </div>

            <button
                type="button"
                className={`${Form.btnAccent} ${canSell ? '' : Form.btnDisabled}`}
                onClick={() => { if (canSell) mainBtnHandler(); }}
            >
                {t('Продать')}
            </button>
        </DsModal>
    );
};

export default CabinetMatrixSellModal;
